/**
 * De verversknop van het ouderportaal.
 *
 * Het leerkrachtportaal geeft al `onRefresh` mee aan `DataFreshness`; het
 * ouderportaal deed dat op geen van zijn pagina's, waardoor daar wel een
 * "laatst bijgewerkt"-label stond maar geen manier om er iets aan te doen.
 * Een tijdsaanduiding zonder verversmogelijkheid is de slechtste combinatie:
 * ze maakt de ouder attent op veroudering en biedt geen uitweg.
 */

import { useCallback, useState } from 'react';
import { toast } from 'sonner';
import { refreshChildProgress, type RefreshableChild } from '../shared/refreshChildProgress';
export function useRefreshChild(children: RefreshableChild[]) {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const refresh = useCallback(async () => {
    if (isRefreshing) return;
    setIsRefreshing(true);
    const res = await refreshChildProgress(children);
    setIsRefreshing(false);
    if (!res.ok) {
      toast.error('Bijwerken is niet gelukt. Controleer je internetverbinding en probeer het opnieuw.');
      return;
    }

    // Ook bij nul wijzigingen een bevestiging. "Er is niets veranderd" is een
    // geldig en geruststellend antwoord; een knop die zwijgt laat de ouder in
    // het ongewisse of er iets gebeurd is.
    toast.success(res.updated > 0 ? 'Bijgewerkt' : 'Je bekijkt de meest recente gegevens');
  }, [children, isRefreshing]);
  return {
    refresh,
    isRefreshing
  };
}